module.exports = __webpack_public_path__ + "img/hero-background-mobile.c13fd4f7.jpg";